// REQ-P1-06b: サーバー状態管理の共通規約(TanStack Query)。
//
// 規約:
// - queryKey は [ドメイン, 識別子...] の配列形式に統一する(例: ['templates', type])。
// - サーバー応答を useState へコピーしない。Queryキャッシュを正本とする。
// - 認証切れ(401)等の横断処理は既存のグローバルfetchパッチが担うため、
//   ここでは再試行とキャッシュ方針のみを定義する。

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 管理画面の参照データは短時間のキャッシュで十分新鮮。
      staleTime: 30 * 1000,
      // ネットワーク一時障害のみを想定し1回だけ再試行(4xxは再試行しない)。
      retry: (failureCount, error: unknown) => {
        const status = (error as { status?: number } | null)?.status;
        if (typeof status === 'number' && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});
